export const ALERT_POSITION = 'top-center';
const webSopes = [
  {
    id: 'cloud', title: 'Cloud', description: 'Portal Interno de clientes Febos'
  },
  {
    id: 'proveedores', title: 'Proveedores', description: 'Portal Proveedores'
  },
  {
    id: 'cliente', title: 'Clientes', description: 'Portal de Clientes'
  }
];
const applications = [
  {
    id: 'FEB', title: 'Febos', description: 'Portal Febos', color: 'orange'
  },
  {
    id: 'ED', title: 'Escritorio Digital', description: 'Escritorio Digital', color: '#7367f0'
  },
  {
    id: 'NRV', title: 'Narvi', description: 'Narvi', color: '#ff2961'
  },
  {
    id: 'ADU', title: 'Aduanas', description: 'Aduanas', color: '#393979'
  },
  {
    id: 'PHQ', title: 'Phoqo', description: 'Phoqo', color: '#00aeef'
  }
];
const levels = [
  {
    id: 'global',
    permission: 'FEB99',
    level: 0,
    icon: 'globe',
    title: 'Nivel Global',
    description: 'Global'
  }, {
    id: 'app',
    permission: 'FEB99',
    level: 1,
    icon: 'app-indicator',
    title: 'Nivel aplicación',
    description: 'Aplicación'
  },
  {
    id: 'portal',
    permission: 'FEB99',
    level: 5,
    icon: 'cloud',
    title: 'Nivel dominio',
    description: 'Dominio WEB'
  },
  {
    id: 'empresa',
    level: 10,
    icon: 'building',
    title: 'Nivel Empresa Global',
    description: 'Empresa'
  },
  {
    id: 'empresaApp',
    level: 11,
    icon: 'calculator-fill',
    title: 'Nivel Empresa en una app',
    description: 'Empresa APP'
  },
  {
    id: 'usuario', level: 30, icon: 'person', title: 'Nivel Usuario Global', description: 'Usuario'
  },
  {
    id: 'usuarioEmpresa',
    level: 31,
    icon: 'file-person',
    title: 'Nivel Usuario en una empresa',
    description: 'Usuario en Empresa'
  },
  {
    id: 'usuarioEmpresaApp',
    level: 31,
    icon: 'intersect',
    title: 'Nivel Usuario en una empresa dentro de una app',
    description: 'Usuario en empresa en aPP'
  }
];

const passToUrl = (url) => {
  if (url.startsWith('/')) {
    return `https:/${url}`;
  }
  return url;
};
const capitalize = (str) => str.replace(/^\w/, (c) => c.toUpperCase());

const findValue = (configuration = {}, levelToFind = 'usuario') => {
  const levelFound = levels.find((level) => level.id === levelToFind);
  return levels
    .filter((level) => level.level <= levelFound.level)
    .map((level) => level.id)
    .map((level) => [level, configuration[`valor${capitalize(level)}`]])
    .reverse()
    .find(([, config]) => config) || ['global', undefined];
};

export {
  levels, applications, webSopes, findValue, capitalize, passToUrl
};
